import * as React from 'react';
import {StatBlock, IStatBlock} from './StatBlock';

interface IStatsBar {
  stats: IStatBlock[];
  bgColour?: string;
}

const desktopColsMap: Record<number, string> = {
  1: 'md:grid-cols-1',
  2: 'md:grid-cols-2',
  3: 'md:grid-cols-3',
  4: 'md:grid-cols-4',
};

export const StatsBar = ({stats, bgColour = 'bg-white'}: IStatsBar) => {
  const desktopCols = desktopColsMap[stats.length] ?? 'md:grid-cols-4';
  return (
    <div className={`${bgColour} rounded-2xl shadow-sm px-8 py-10`}>
      <div className={`grid grid-cols-2 ${desktopCols} gap-8`}>
        {stats.map((stat, i) => (
          <StatBlock key={i} {...stat} />
        ))}
      </div>
    </div>
  );
};
